<template>
  <v-snackbar v-model="internalValue" top right color="success" class="success-operation-message">
    {{ message }}
  </v-snackbar>
</template>
<script>
export default {
  name: 'SuccessOperationMessage',
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  computed: {
    internalValue: {
      get() {
        return !!this.message;
      },
      set() {
        this.$emit('close');
      },
    },
  },
};
</script>
